import axios from 'axios';
import { toast } from 'react-toastify';
import {
  EVENTS_UPDATE_ACTION_BEGIN,
  EVENTS_UPDATE_ACTION_SUCCESS,
  EVENTS_UPDATE_ACTION_FAILURE,
  EVENTS_UPDATE_ACTION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateAction(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_UPDATE_ACTION_BEGIN,
    });
    const { projectId, version, eventId, data } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events/${eventId}/actions/${data.uuid}`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EVENTS_UPDATE_ACTION_SUCCESS,
            data: res,
          });
          Mixpanel.track('Updated action in event');
          toast.success('Updated Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EVENTS_UPDATE_ACTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to update action in event');
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Updation Failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateActionError() {
  return {
    type: EVENTS_UPDATE_ACTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_UPDATE_ACTION_BEGIN:
      return {
        ...state,
        updateActionPending: true,
        updateActionError: null,
      };

    case EVENTS_UPDATE_ACTION_SUCCESS:
      return {
        ...state,
        updateActionPending: false,
        updateActionError: null,
      };

    case EVENTS_UPDATE_ACTION_FAILURE:
      return {
        ...state,
        updateActionPending: false,
        updateActionError: action.data.error,
      };

    case EVENTS_UPDATE_ACTION_DISMISS_ERROR:
      return {
        ...state,
        updateActionError: null,
      };

    default:
      return state;
  }
}
